import { Reveal, Tag, Heading } from "../Reveal";
import { CompareSlider } from "./CompareSlider";

const PROJECTS = [
  { cat: "Commercial rehabilitation", title: "Complete building rehabilitation", before: "/images/home/p1-before.jpg", after: "/images/home/p1-after.jpg" },
  { cat: "Kitchen remodeling", title: "Modern kitchen transformation", before: "/images/home/p2-before.jpg", after: "/images/home/p2-after.jpg" },
  { cat: "Bathroom remodeling", title: "Luxury master bathroom", before: "/images/home/p3-before.jpg", after: "/images/home/p3-after.jpg" },
];

export const HomeProjects = () => (
  <section id="projects" className="py-24 lg:py-40 bg-sand" data-testid="home-projects-section">
    <div className="mx-auto max-w-[1600px] px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <Reveal className="lg:col-span-7">
          <Tag>Recent projects</Tag>
          <Heading className="mt-6">Drag to see the difference.</Heading>
        </Reveal>
        <Reveal className="lg:col-span-4 lg:col-start-9" delay={0.1}>
          <p className="text-base sm:text-lg text-ink/70 leading-relaxed">Drag the handle to see the dramatic transformations we deliver — and the quality and attention to detail that sets us apart.</p>
        </Reveal>
      </div>

      <div className="mt-16 grid lg:grid-cols-3 gap-6 lg:gap-8">
        {PROJECTS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.1}>
            <CompareSlider before={p.before} after={p.after} alt={p.title} testId={`compare-slider-${i}`} />
            <div className="mt-5 flex items-start justify-between gap-4 border-t border-ink/15 pt-4">
              <div>
                <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink/50">{p.cat}</p>
                <h3 className="mt-2 font-display font-medium text-xl sm:text-2xl tracking-[-0.015em] text-ink">{p.title}</h3>
              </div>
              <span className="font-display font-semibold text-3xl tracking-[-0.03em] text-ink/15">{String(i + 1).padStart(2, "0")}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
